module.exports = __webpack_public_path__ + "static/media/login-img.fc39392c.jpg";